// extracted by mini-css-extract-plugin
export default {"container":"styles_container__A5lxp","hints":"styles_hints__30tbY"};